// extracted by mini-css-extract-plugin
module.exports = {"page":"StartPage_page__ZJF07","welcomeSegment":"StartPage_welcomeSegment__1Mikc","companyLogoSegment":"StartPage_companyLogoSegment__2b0N3"};